import {Stack, Typography, Divider} from '@mui/material';
import { Link } from 'react-router-dom';
import MailLogin from "../components/MailLogin";
import SmsLogin from "../components/SmsLogin";

const Login = () => {
    
  return (
    <>
      <Typography variant="h4" sx={{ fontWeight: 'bold' }} gutterBottom>
        Logg inn
      </Typography>
      <Typography variant="body1" sx={{ maxWidth: '500px' }} gutterBottom>
        Det er mulig å bruke logge inn med epost eller sms. Ved å bruke denne applikasjonen <Link to="/terms">godtar du våre vilkår for bruk.</Link>
      </Typography>
      <Stack spacing={3}>
        <MailLogin />
        <Divider />
        <SmsLogin />
      </Stack>
    </>
  );
};

export default Login;
